import httpService from '@/services/httpService'

export const types = {
  ADD_CLIENTS: 'clients/ADD_CLIENTS',
  ADD_AGENCIES_OPTIONS: 'clients/ADD_AGENCIES_OPTIONS',
  ADD_DEVICE_OPTIONS: 'clients/ADD_DEVICE_OPTIONS',
  ADD_GEO_OPTIONS: 'clients/ADD_GEO_OPTIONS',
  ADD_LOCALE_OPTIONS: 'clients/ADD_LOCALE_OPTIONS',
  ADD_CLIENT_DATA: 'clients/ADD_CLIENT_DATA',
  ADD_AUDIENCE_KEYS: 'clients/ADD_AUDIENCE_KEYS',
  CHANGE_IS_SETTING_QUERIED_STATUS: 'clients/CHANGE_IS_SETTING_QUERIED_STATUS'
}
const state = {
  clients: [],
  agencies: [],
  geo: [],
  device: [],
  locale: [],
  audienceKeys: [],
  isSettingsQueried: false,
  clientData: {}
}

const mutations = {
  [types.ADD_CLIENTS]: function (state, clients) {
    state.clients = clients
  },
  [types.CHANGE_IS_SETTING_QUERIED_STATUS]: function (state) {
    state.isSettingsQueried = true
  },
  [types.ADD_AGENCIES_OPTIONS]: function (state, agencies) {
    state.agencies = agencies
  },
  [types.ADD_GEO_OPTIONS]: function (state, geo) {
    state.geo = geo
  },
  [types.ADD_DEVICE_OPTIONS]: function (state, device) {
    state.device = device
  },
  [types.ADD_LOCALE_OPTIONS]: function (state, locale) {
    state.locale = locale
  },
  [types.ADD_CLIENT_DATA]: function (state, clientData) {
    state.clientData = clientData
  },
  [types.ADD_AUDIENCE_KEYS]: function (state, audienceKeys) {
    state.audienceKeys = audienceKeys
  }
}

const actions = {
  getClientsData: async function ({ commit }) {
    const response = await httpService.get(`/clients`)
    if (!response || !response.data) {
      commit(types.ADD_CLIENTS, [])
    }
    commit(types.ADD_CLIENTS, response.data.clients)
    return response.data
  },
  getDataByClient: async function ({ commit }, clientId) {
    const response = await httpService.get(`/clients/${clientId}`)
    if (!response || !response.data) {
      commit(types.ADD_CLIENT_DATA, {})
      commit(types.ADD_AUDIENCE_KEYS, [])
      return {}
    }
    commit(types.ADD_CLIENT_DATA, response.data.data)
    commit(types.ADD_AUDIENCE_KEYS, response.data.audience_keys)
    return response.data
  },
  getClientsSettings: async function ({ commit }, clientId) {
    const response = await httpService.get(`/clients/settings/${clientId}`)
    if (!response || !response.data) {
      commit(types.ADD_GEO_OPTIONS, [])
      commit(types.ADD_DEVICE_OPTIONS, [])
      commit(types.ADD_LOCALE_OPTIONS, [])
      commit(types.ADD_AGENCIES_OPTIONS, [])
      return {}
    }
    commit(types.CHANGE_IS_SETTING_QUERIED_STATUS)
    commit(types.ADD_GEO_OPTIONS, response.data.geo)
    commit(types.ADD_DEVICE_OPTIONS, response.data.device)
    commit(types.ADD_LOCALE_OPTIONS, response.data.locale)
    commit(types.ADD_AGENCIES_OPTIONS, response.data.agencies)
    return response.data
  },
  getSetupOptions: async function ({ commit }) {
    const response = await httpService.get(`/clients/setup-options`)
    if (!response || !response.data) {
      commit(types.ADD_GEO_OPTIONS, [])
      commit(types.ADD_DEVICE_OPTIONS, [])
      commit(types.ADD_LOCALE_OPTIONS, [])
      return {}
    }
    commit(types.ADD_GEO_OPTIONS, response.data.geo)
    commit(types.ADD_DEVICE_OPTIONS, response.data.device)
    commit(types.ADD_LOCALE_OPTIONS, response.data.locale)
    return response.data
  },
  changeClientStatus: async function (storage, params) {
    const response = await httpService.patch(`/clients/change_status`, params, { successMessage: 'Project status updated successfully' })
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  createUpdateClient: async function (storage, { clientData, clientId, method }) {
    const request = httpService[method]
    const response = await request(`/clients/${clientId}`, { client_data: clientData })
    if (!response || !response.data) {
      return false
    }
    return response.data
  },
  deleteClientById: async function (storage, clientId) {
    const response = await httpService.delete(`/clients/${clientId}`, { successMessage: 'Project removed successfully', raiseError: true })
    return response.data
  },
  createClientAggregation: async function (storage, clientId) {
    const response = await httpService.post(`/clients/aggregations/${clientId}`, null, { successMessage: 'Project Aggregation added to queue', raiseError: true })
    return response.data
  },
  resetClientData: async function ({ commit }) {
    commit(types.ADD_CLIENT_DATA, {})
    commit(types.ADD_AUDIENCE_KEYS, [])
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
